function convertMeterToFeet(num) {
  let eq =
    "Converting " +
    num +
    " meters to feet: \n" +
    num +
    " * 3.2808 = ";
  let rep = num * 3.2808;
  return eq + rep.toFixed(3);
}

function convertMeterToInches(num) {
  let eq =
    "Converting " + num + " meters to inches: \n" + num + " * 39.370 = ";
  let rep = num * 39.370;
  return eq + rep.toFixed(3);
}

function convertMeterToYards(num) {
  let eq =
    "Converting " +
    num +
    " meters to yards: \n" +
    num +
    " * 1.0936 = ";
  let rep = num * 1.0936;
  return eq + rep.toFixed(3);
}

function convertMeterToMiles(num) {
  let eq =
    "Converting " +
    num +
    " meters to miles: \n" +
    num +
    " * 0.00062137 = ";
  let rep = num * 0.00062137;
  return eq + rep.toFixed(5);
}

function convertMeterToCM(num) {
  let eq =
    "Converting " +
    num +
    " meters to centimeters: \n" +
    num +
    " / 0.01 = ";
  let rep = num / 0.01;
  return eq + rep.toFixed(3);
}

function convertMeterToKilometers(num) {
  let eq =
    "Converting " +
    num +
    " meters to kilometers: \n" +

    num +
    " / 1000 = ";
  let rep = num / 1000;
  return eq + rep.toFixed(5);
}

export {
  convertMeterToFeet,
  convertMeterToInches,
  convertMeterToYards,
  convertMeterToMiles,
  convertMeterToCM,
  convertMeterToKilometers
};
